// extracted by mini-css-extract-plugin
export default {"preloader-plus":"authInitilizer_preloader-plus__ZmZzu","preloader-custom-img":"authInitilizer_preloader-custom-img__xbPae","preloader-fade":"authInitilizer_preloader-fade__8PqSw"};